import { useAuthStore } from "presentation/stores/use-auth-store";
import { useEffect } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import Container from "../../components/Layout/Container";
import Content from "../../components/Layout/Content";
import Sidebar from "../../components/Layout/Sidebar";
import { useEmployeesByFilter } from "presentation/hooks/use-query-employees";
import { EmployeeInputFilter } from "domain/models/employee-input-filter";
import { useUserByFilter } from "presentation/hooks/use-query-user";
import { UserInputFilter } from "domain/models/user-input-filter";
import { PermissionInputFilter } from "domain/models/permission-input-filter";
import { usePermissionByFilter } from "presentation/hooks/use-query-permission";
import { Permission } from "domain/entities/permission";
import { useRolesStore } from "presentation/stores/use-roles-list-store";
import { useImpersonationStore } from "presentation/stores/use-impersonation-store";
import "./index.css";
import Spinner from "presentation/components/Shared/Spinner";
import { clearLocalStorage } from "presentation/utils/localStorage";

const Home = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const token = useAuthStore((state) => state.accessToken);
  const expiresAt = useAuthStore((state) => state.expiresAt);
  const userName = useAuthStore((state) => state.userName);
  const {
    setUserEmployee,
    email,
    setUserPermissions,
    clearAuth,
  } = useAuthStore();
  const { isDebugMode } = useImpersonationStore();
  const { setRoles } = useRolesStore();
  const { data: employeeData, refetch: employeeRefetch } = useEmployeesByFilter(
    {
      email: email,
    } as EmployeeInputFilter
  );

  const { data: permissionsData, refetch: rolesRefetch } =
    usePermissionByFilter({
      limit: 100,
    } as PermissionInputFilter);

  const { data: userData, refetch: userRefetch } = useUserByFilter({
    email: email,
  } as UserInputFilter);

  useEffect(() => {
    if (employeeData?.data && !isDebugMode) {
      setUserEmployee(employeeData.data[0]);
      if (employeeData.data[0].isActive === false) {
        clearAuth();
        clearLocalStorage();
        navigate("/login?unauthorized=true");
      }
    }
  }, [employeeData, isDebugMode]);

  useEffect(() => {
    if (userData?.data && !isDebugMode) {
      setRoles(userData.data[0].roles);
    }
  }, [userData, isDebugMode]);

  useEffect(() => {
    employeeRefetch();
    userRefetch();
  }, [email]);

  useEffect(() => {
    if (userData?.data && userData.data[0].roles.length > 0 && !isDebugMode) {
      let permissions: Permission[] = [];
      userData?.data[0].roles.map((item) => {
        const selectedPermission = permissionsData?.data?.filter(
          (subitem) => subitem.roleId === item.id
        );
        permissions = [...permissions, ...(selectedPermission || [])];
      });
      setUserPermissions(permissions);
      if (location.pathname === "/" || location.pathname === "/login") {
        navigate("/dashboards");
      }
    }
  }, [userData, permissionsData, isDebugMode]);

  useEffect(() => {
    if (!token || expiresAt < new Date().getTime()) {
      navigate("/login");
    }
  }, [token, expiresAt, userName]);

  if (!permissionsData) return <Spinner />;

  return (
    <Container>
      <Sidebar />
      <Content>
        <Outlet />
      </Content>
    </Container>
  );
};

export default Home;
